/**
 * AvocatEnOrLogo — logo officiel "Un Avocat en Or".
 *
 * Utilise le dessin original dessiné à la main par le fondateur, transformé en
 * doré (#D4AF37) sur fond noir (#0A0A0A). Le fichier source PNG est servi
 * depuis /logo-hand-drawn.png (généré via /tmp/transform_logo.py).
 *
 * Props :
 *   - size: number (default 64) — taille en pixels (carré)
 *   - variant: "full" (image complète) | "mark" — actuellement identiques
 *   - background: "black" | "transparent" — la transparence garde le noir interne
 *   - className: classes Tailwind additionnelles
 */
export default function AvocatEnOrLogo({
  size = 64,
  variant = "full",  // eslint-disable-line no-unused-vars
  background = "black",  // eslint-disable-line no-unused-vars
  className = "",
  ...rest
}) {
  return (
    <img
      src="/logo-hand-drawn.png"
      alt="Un Avocat en Or"
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className={className}
      style={{
        display: "block",
        width: `${size}px`,
        height: `${size}px`,
        objectFit: "contain",
      }}
      {...rest}
    />
  );
}

// Wordmark — gardé pour compatibilité avec les imports existants
export function AvocatEnOrWordmark({ className = "", color = "gold" }) {
  const main = color === "ivory" ? "#F5E9D0" : "#D4AF37";
  return (
    <span
      className={`font-serif-display tracking-tight ${className}`}
      style={{ color: main, fontStyle: "italic", fontWeight: 500 }}
    >
      Un <span style={{ fontWeight: 700 }}>Avocat</span> <span style={{ letterSpacing: "0.05em" }}>en Or</span>
    </span>
  );
}
